import { Accordion, Section } from '@pkdigital/pkd-custom-components';
import { TFunction } from 'i18next';
import React, { ReactNode } from 'react';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useClientSide } from '../../utils/useClientSide';

type Item = {
  title: ReactNode;
  content: ReactNode;
};

function getItems(t: TFunction): Array<Item> {
  return [
    {
      title: t('faqSection.accordion.q1.title'),
      content: <p>{t('faqSection.accordion.q1.content')}</p>
    },
    {
      title: t('faqSection.accordion.q2.title'),
      content: <p>{t('faqSection.accordion.q2.content')}</p>
    },
    {
      title: t('faqSection.accordion.q3.title'),
      content: <p>{t('faqSection.accordion.q3.content')}</p>
    },
    {
      title: t('faqSection.accordion.q4.title'),
      content: <p>{t('faqSection.accordion.q4.content')}</p>
    },
    {
      title: t('faqSection.accordion.q5.title'),
      content: (
        <>
          <p className="mb-3">{t('faqSection.accordion.q5.content1')}</p>
          <p className="mb-3">{t('faqSection.accordion.q5.content2')}</p>
          <p>{t('faqSection.accordion.q5.content3')}</p>
        </>
      )
    }
  ];
}

export function FAQSection() {
  const { t } = useTranslation();
  const isClient = useClientSide();

  if (!isClient) return null;

  return (
    <Container className={'faq'}>
      <Section headline={t('faqSection.title')} className="faq">
        <Accordion className="accordion" items={getItems(t)} />
      </Section>
    </Container>
  );
}
